import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/LoginView.vue";
import { dictionary } from "../helpers";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/booking",
    name: "Booking",
    component: () => import("../views/BookingView.vue")
  },
  {
    path: "/history",
    name: "History",
    component: () => import("../views/BookingHistoryView.vue")
  },
  {
    path: "/user",
    name: "User",
    component: () => import("../views/UserView.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/ContactView.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem(
    dictionary.constants.authentication.jwt
  );

  if (authRequired && (!loggedIn || !isAuthenticated())) {
    //user router.push('/') instead of next('/') to avoid exception in promise, but only if not navigatied from '/'
    router.push({ path: "/" });
  }

  next();
});

function isAuthenticated() {
  try {
    const jwt = JSON.parse(
      localStorage.getItem(dictionary.constants.authentication.jwt)
    );
    const base64Url = jwt.token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    const exp = JSON.parse(jsonPayload).exp;

    if (exp < (new Date().getTime() + 1) / 1000) {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
}

export default router;
